import { useState } from 'react';
import cls from 'classnames';
import { Image, Modal, Button } from 'react-bootstrap';
import { useFormatLocalization } from 'src/utils/hooks';
import { withModalDialog, useModalDialog, ConfirmModalDialog } from 'src/components/base/ModalDialog';
import classes from './ImageGallery.module.scss';

export const ImageGallery = withModalDialog(({ images = [], index = 0, onClose, deleteImage }) => {
  const [currentIndex, setCurrentIndex] = useState(index);
  const deleteModal = useModalDialog();

  const selectedImage = images[currentIndex];
  const hasPrevious = currentIndex > 0;
  const hasNext = currentIndex < images.length - 1;

  const title = useFormatLocalization(__('Image: {index} of {total}'), {
    index: currentIndex + 1, total: images.length
  }, [currentIndex, images.length]);

  async function handleDeleteClick() {
    if (await deleteModal.show({ text: __('Do you want to delete this image?') })) {
      await deleteImage(selectedImage);
      onClose();
    }
  }

  function handleCloseModal() {
    onClose();
  }

  function handlePrevious() {
    if (hasPrevious) {
      setCurrentIndex(currentIndex - 1);
    }
  }

  function handleNext() {
    if (hasNext) {
      setCurrentIndex(currentIndex + 1);
    }
  }

  return (
    <>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center position-relative">
        <div className="position-relative">
          <Image src={selectedImage.file_url} alt={selectedImage.name} fluid className={classes.fullSizeImage} />

          {hasPrevious && (
            <Button variant="light" className={cls(classes.navButton, classes.prevButton)} onClick={handlePrevious} size="lg">
              <i className="bi bi-chevron-left"></i>
            </Button>
          )}

          {hasNext && (
            <Button
              variant="light"
              className={cls(classes.navButton, classes.nextButton)}
              onClick={handleNext}
              size="lg"
            >
              <i className="bi bi-chevron-right"></i>
            </Button>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleDeleteClick}>{__('Delete Image')}</Button>
        <div className="flex-fill" />
        <Button variant="secondary" onClick={handleCloseModal}>{__('Close')}</Button>
      </Modal.Footer>

      <ConfirmModalDialog {...deleteModal.register()} />
    </>
  )
}, { size: 'lg' })